import { Platform, StatusBar } from "react-native";

/**
 * Insets that keep UI clear of status bars / notches / Android system nav
 * across phone sizes (gesture and 3-button nav).
 */

export function getTopInset() {
  if (Platform.OS === "android") {
    const h = StatusBar.currentHeight;
    return h && h > 0 ? h : 28;
  }
  if (Platform.OS === "ios") return 50;
  return 0;
}

/** Space above the system navigation / gesture bar. */
export function getBottomInset() {
  if (Platform.OS === "android") return 48;
  if (Platform.OS === "ios") return 28;
  return 0;
}
